import { SvgComponentProps } from "@/src/types/SVGPropType"
import * as React from "react"
const Hobby1SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M8.75 6.06v-.75h-1.5v4.94L5.78 8.78l-.53-.53-1.06 1.06.53.53 2.75 2.75a.75.75 0 0 0 1.06 0l2.75-2.75.53-.53-1.06-1.06-.53.53-1.47 1.47V6.06ZM1.5 8.81a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Zm6.5-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Hobby1SVG
